import { Box, Stack, Typography } from '@mui/material';
import 'dayjs/locale/it';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../hooks/appContext';
import useCabledMutation from '../../hooks/useCabledMutation';
import { useCabledQuery } from '../../hooks/useCabledQuery';
import { alertService } from '../../services/alerting/alerting';
import ItpaApi from '../../services/api';
import { queryAwaiter } from '../../services/common/common';
import OpinionatedForm from '../forms/opinionatedForm';
import { useQueryClient } from '@tanstack/react-query';
const AdminEditIncidentType = ({
    problemType,
    onSuccess = () => { },
    onCancel = () => { }
}) => {
    const { currentEnvironment } = useContext(AppContext);
    const [formValues, setFormValues] = useState({});
    const queryClient = useQueryClient();
    const { query: problemTypeQuery, queryKey: problemTypeQueryKey  } = useCabledQuery({
        apiService: "monitoring",
        method: "describeProblemType",
        baseQueryKey: 'problemType',
        refetchInterval: 10 * 60 * 1000,
        filters: { environment: currentEnvironment, problemType }
    });
    const { query: flowsQuery } = useCabledQuery({
        apiService: "monitoring",
        method: "listAllFlows",
        baseQueryKey: 'all_flows',
        refetchInterval: 10 * 60 * 1000,
        filters: { environment: currentEnvironment }
    });

    const moniServ = ItpaApi.getService("monitoring");


    const createIncidentTypeMutation = useCabledMutation({
        apiService: 'monitoring',
        method: 'createProblemType',
        onSuccess: (result) => {
            alertService.success("Incident type updated " + JSON.stringify(result, null, 2));
            queryClient.invalidateQueries(problemTypeQueryKey);
            return onSuccess();
        },
        onFailure: (e) => {
            alertService.error("Cannot update incident type")
        }
    })
    const loadFlows = queryAwaiter({
        query: flowsQuery,
        transformData: data=>data?.map(x => x.name) || [],
        trasformError: () => []
    });

    if (problemTypeQuery.isLoading) return <>Loading...</>
    if (problemTypeQuery.isError) return <>Cannot get details about this incident type</>
    const initialRules = {};
    for (let rule of problemTypeQuery.data?.flow_rules || []){
        initialRules[rule.severity_min] = rule.flow_name;
    }

    const fields = [
       
        {
            name: 'severity1', type: 'select', label: 'On warning', getOptions: loadFlows, initialValue: initialRules[1] || undefined
        }, {
            name: 'severity2', type: 'select', label: 'On minor', getOptions: loadFlows, initialValue: initialRules[2] || undefined
        }, {
            name: 'severity3', type: 'select', label: 'On major', getOptions: loadFlows, initialValue: initialRules[3] || undefined
        }, {
            name: 'severity4', type: 'select', label: 'On critical', getOptions: loadFlows, initialValue: initialRules[4] || undefined
        }

    ];
    const buttons = [
        { name: "Cancel", onClick: () => onCancel(), color: "error" },
        {
            name: "Update", onClick: () => {
                let payload = { environment: currentEnvironment, problemType: problemType, flowRules: []};
                if (formValues.severity1) payload.flowRules.push({ flow_name: formValues.severity1, severity_min: 1 });
                if (formValues.severity2) payload.flowRules.push({ flow_name: formValues.severity2, severity_min: 2 });
                if (formValues.severity3) payload.flowRules.push({ flow_name: formValues.severity3, severity_min: 3 });
                if (formValues.severity4) payload.flowRules.push({ flow_name: formValues.severity4, severity_min: 4 });
                
                let x = createIncidentTypeMutation.mutate(payload);
                
            }, color: "success", disabled: (formIsValid) => !formIsValid
        }
    ];

    return (
        <Stack spacing={2} sx={{ minWidth: "25vw" }} alignItems="center">
            <Box sx={{ height: "10vh" }} />
            <Typography variant="h6" component="div" gutterBottom>Edit incident type</Typography>
            <Typography variant="h5" component="div" gutterBottom>{problemType}</Typography>
            <OpinionatedForm fields={fields} buttons={buttons} formValues={formValues} setFormValues={setFormValues} displayJson={true} validateOnChange={true} />
        </Stack>

    )
}



export default AdminEditIncidentType